import { render, staticRenderFns } from "./PopinLayout.vue?vue&type=template&id=0a3dc2a3&scoped=true&"
import script from "./PopinLayout.vue?vue&type=script&lang=js&"
export * from "./PopinLayout.vue?vue&type=script&lang=js&"
import style0 from "./PopinLayout.vue?vue&type=style&index=0&id=0a3dc2a3&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3dc2a3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonClose: require('/opt/build/repo/components/ButtonComponents/ButtonClose.vue').default})
